import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=76d33e08&"
import script from "./appointment.vue?vue&type=script&lang=js&"
export * from "./appointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports